var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pfs-curveplot-container"},[_c('pfs-curveplot',{attrs:{"studySelected":_vm.studySelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }